import data from "./routes.json";
import { buildSchema } from "./schema";

const SITE = data.site;

export const normalizePath = (p) => {
  let x = (p || "/").split("?")[0].split("#")[0];
  if (x.length > 1) x = x.replace(/\/+$/, "");
  return x || "/";
};

function setMeta(attr, key, content) {
  const els = document.head.querySelectorAll("meta[" + attr + '="' + key + '"]');
  let el = els[0];
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  for (let i = 1; i < els.length; i += 1) els[i].remove();
}

function setCanonical(href) {
  const els = document.head.querySelectorAll('link[rel="canonical"]');
  els.forEach((e, i) => {
    if (i > 0 || !href) e.remove();
  });
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(obj) {
  document.head.querySelectorAll('script[type="application/ld+json"][data-seo]').forEach((e) => e.remove());
  if (!obj) return;
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.setAttribute("data-seo", "1");
  s.text = JSON.stringify(obj);
  document.head.appendChild(s);
}

export function applySeo(pathname) {
  const path = normalizePath(pathname);
  const route = data.routes.find((r) => r.path === path);
  const title = route ? route.title : data.notFound.title;
  const description = route ? route.description : data.notFound.description;
  const robots = route ? route.robots : "noindex,follow";
  const canonical = route ? SITE + (path === "/" ? "/" : path) : null;
  const image = SITE + data.ogImage;

  document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "robots", robots);
  setCanonical(canonical);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:site_name", data.siteName);
  setMeta("property", "og:locale", "en_IN");
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  if (canonical) setMeta("property", "og:url", canonical);
  setMeta("property", "og:image", image);
  setMeta("property", "og:image:width", String(data.ogImageWidth));
  setMeta("property", "og:image:height", String(data.ogImageHeight));
  setMeta("property", "og:image:alt", "Formax Connect payment technology dashboard");
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
  setJsonLd(route && route.robots.indexOf("noindex") === -1 ? buildSchema(route) : null);
}
